import { useEffect, useState } from "react";
import { scrollToId } from "./Reveal";
import { useLang } from "../../i18n";

export const MobileCTA = () => {
  const [show, setShow] = useState(false);
  const { t } = useLang();
  useEffect(() => {
    const on = () => {
      const form = document.getElementById("reserva");
      const inForm = form && form.getBoundingClientRect().top < window.innerHeight && form.getBoundingClientRect().bottom > 0;
      setShow(window.scrollY > 500 && !inForm);
    };
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <div
      className={`fixed inset-x-3 bottom-3 z-40 transition-[transform,opacity] duration-500 md:hidden ${show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-24 opacity-0"}`}
    >
      <button
        onClick={() => scrollToId("reserva")}
        data-testid="mobile-sticky-cta"
        className="flex w-full items-center justify-between rounded-full bg-[#2D2D2D] py-2 pl-5 pr-2 text-sm font-bold text-[#FDFBF7] shadow-2xl"
      >
        <span>{t.mobileCta.text}</span>
        <span className="rounded-full bg-[#F26D5A] px-4 py-2.5 text-[#1f1f1f]">{t.mobileCta.btn}</span>
      </button>
    </div>
  );
};
